import { rankWith, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
// import { Button, DropdownMultiSelect, PlusIcon } from '../../elements/Button';
import { Button } from '../../elements/Button';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import './style.scss';

const MultiSelectControl = ({
  schema,
  data,
  handleChange,
  handleBlur,
  path,
}: FieldProps) => {
  // @ts-ignore
  const optionsOneOf = schema.items?.oneOf;
  const mappedOption = optionsOneOf?.map((item: any) => {
    return { label: item.title, value: item.const };
  });

  return (
    <div className="boolean-select-wrapper">
      <div
      //@ts-ignore
        items={mappedOption}
        value={data}
        hasCheckBox={false}
        onChange={(value) => {
          handleChange(path, value);
        }}
        onBlur={() => handleBlur(path)}
      >
        <Button type="secondary" classes="tru-plus-btn">
          <span/>
        </Button>
      </div>
      {schema.description && (
        <p className="description">{schema.description}</p>
      )}
    </div>
  );
};

export const MultiSelectControlEntry = {
  tester: rankWith(3, uiTypeIs('MultiSelect')),
  renderer: withJsonFormsControlProps(
    WithDynamicFormContext(MultiSelectControl),
  ),
};
